import { Component, h } from 'preact';
import cx from 'classnames';
import debounce from 'lodash-es/debounce';


import { DivCat, ReqState, Location } from '../../../../types';

import { MultiChipInput } from './multi-chip-input.component';
import { locationService } from '../../../utils/location.service';

interface MultiLocationFieldProps {
  divCat: DivCat;
  locations: Location[];
  showInvalidState?: boolean;

  onLocationsChange: (locations: Location[]) => void;
}

interface MultiLocationFieldState {
  textInput?: string;
  searchResults?: Location[];
  searchReqState?: ReqState;
}

export class MultiLocationField extends Component<MultiLocationFieldProps, MultiLocationFieldState> {

  doSearch = debounce(async (searchString: string) => {
    this.setState({ searchReqState: ReqState.IN_PROGRESS });
    try {
      const response = await locationService.linearSearch(searchString, this.props.divCat, 5);
      this.setState({
        searchReqState: ReqState.SUCCESS,
        searchResults: response.data.results
      });
    } catch (err) {
      this.setState({ searchReqState: ReqState.FAILED });
    }
  });

  async onTextInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const text = target.value;

    this.setState({ textInput: text });

    if (text && text.length >= 3) {
      this.doSearch(text); 
    } else {
      this.setState({ searchResults: [] });
    }
  }

  onLocationClick(selectedLoc: Location) {
    const currentLocations = this.props.locations || [];
    this.setState({
      searchResults: [],
      textInput: ''
    });

    if (!currentLocations.find(location => location.uId === selectedLoc.uId)) {
      this.props.onLocationsChange([ ...currentLocations, selectedLoc ]);
    }
  }

  onChipRemove(label: string) {
    const locations = [ ...this.props.locations ];

    const index = locations.findIndex(loc => loc.label === label);
    locations.splice(index, 1);

    this.props.onLocationsChange(locations);
  }

  render(props: MultiLocationFieldProps, state: MultiLocationFieldState) {
    const results = state.searchResults || [];
    const selected = props.locations || [];

    return (
      <div className="position-relative">
        <MultiChipInput
          chipValues={ selected.map(loc => loc.label) }
          onChipListChange={ () => null }
          onChipRemove={ removed => this.onChipRemove(removed) }
          textValue={ state.textInput }
          onInput={ debounce(event => this.onTextInput(event), 500) }
          showInvalidState={ props.showInvalidState }
          placeholder="You can add multiple locations" />
        <div className={ cx('hi-location-search-box__results', { 'active': results && results.length > 0 }) }>
          { results.map(location =>
            <div className="hi-gensearchin__item" onClick={ () => this.onLocationClick(location) }>
              <span className="hi-gensearchin__item-label">{ location.label }</span>
              <span className="hi-gensearchin__item-info">{ location.level }</span>
            </div>
          ) }
        </div>
      </div>
    );
  }
}
